import * as React from 'react';
import { colors } from '../../../index';

const IconPause = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 23 23",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.159 0 0 5.159 0 11.5S5.159 23 11.5 23 23 17.841 23 11.5 17.841 0 11.5 0zm0 21.083c-5.284 0-9.583-4.299-9.583-9.583S6.216 1.917 11.5 1.917s9.583 4.299 9.583 9.583-4.299 9.583-9.583 9.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.014 6.838a.933.933 0 00-.933.932v7.46a.933.933 0 001.865 0V7.77a.933.933 0 00-.932-.932zm4.972 0a.933.933 0 00-.932.932v7.46a.933.933 0 001.865 0V7.77a.933.933 0 00-.933-.932z"
  })));
};

export default IconPause;